module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (41).02eb2a86.jpg";